// Lightweight client-side error reporting to the backend monitoring endpoint.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

let lastSent = 0;
export function reportClientError(message, stack, url) {
  try {
    const now = Date.now();
    if (now - lastSent < 1500) return; // basic throttle to avoid floods
    lastSent = now;
    fetch(`${BACKEND}/api/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        message: String(message || "Unknown client error").slice(0, 2000),
        stack: stack ? String(stack).slice(0, 8000) : null,
        url: url || window.location.href,
        user_agent: navigator.userAgent,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* never throw from the reporter */
  }
}

export function installGlobalErrorHandlers() {
  window.addEventListener("error", (e) => {
    reportClientError(e.message, e.error?.stack, window.location.href);
  });
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    reportClientError(
      reason?.message || `Unhandled promise rejection: ${reason}`,
      reason?.stack,
      window.location.href,
    );
  });
}
